import React from "react";
import {
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput,
} from "react-admin";
import VideoUpload from "../upload/FileUploader";
import { FormToolbar } from "../../common/FormToolbar";

export const CustomerGroupCreate = (props) => {
  return (
    <Create title="Customer Group Create" {...props} undoable={false} >
      <SimpleForm redirect="list" toolbar={<FormToolbar {...props} showDelete={false} />} variant="outlined" >
      <TextInput source="code" initialValue={"Auto"}  fullWidth={true}  validate={[required()]} disabled={true}/>
       <TextInput source="name"  fullWidth={true}  validate={[required()]}/>
        
        <BooleanInput source="isActive" validate={[required()]}  label="Active" initialValue={true} />
      </SimpleForm>
    </Create>
  );
};
